<script>
  /**
   * A category: a small square in the colour set's emphasis colour, then the tag's name.
   * The name is always written out, so the colour is never the only signal.
   */
  import { generate_css_variables } from '#lib/util.js';

  let {
    /** @type {{ tag_key: string, color_id: string }} */
    category,
    /** @type {string} text style class for the name */
    text_style = 'text-preamble',
    /** @type {boolean} only the mark, the name stays available to screen readers */
    mark_only = false,
    /** @type {boolean} a long name wraps instead of ending in "…" (where it is the content) */
    wrap = false,
    class: css_class = '',
  } = $props();
</script>

<span class='category-label {text_style} {css_class}' class:wrap>
  <i class='category-mark' style={generate_css_variables(category.color_id)} aria-hidden='true'></i>
  <span class='category-name' class:visually-hidden={mark_only}>{category.tag_key}</span>
</span>

<style>
  .category-label {
    display: inline-flex;
    max-width: 100%;
    align-items: baseline;
    gap: var(--size-3);
    min-width: 0;
  }
  .category-mark {
    flex: none;
    width: 0.62em;
    height: 0.62em;
    border-radius: var(--mark-radius);
    background: var(--color-emphasis-background);
    /* sits on the cap height of the label, not on its baseline */
    transform: translateY(-0.04em);
  }
  .category-name {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    .wrap & {
      white-space: normal;
    }
  }
</style>
